import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { useLoader } from "../../components/loader/loader";
import { ApiUrl } from "../../config/apiConfig";
import { postData, putData } from "../../services/Axios/Axios";
import messageService from "../../services/message/messageService";
import {
    OnlyEnterNumber,
    isEmptyString,
    showAPiError_mesage,
} from "../../services/validationService/validationservice";
import Modal from "react-modal";
import pluseicon from "./../../assets/img/close-circle.svg";
import PhoneInput from "react-phone-input-2";

interface AddBoxTruckProps {
    isOpen: boolean;
    openModal: any;
    closeModal: () => void;
    getDataALLs?: () => void;
    selectedPriorities?: any;
}

const AddBoxTruck = React.forwardRef((props: AddBoxTruckProps, ref) => {
    const { isOpen, openModal, closeModal } = props;
    const { show, hide } = useLoader();
    const refd: any = useRef(null);

    useEffect(() => {
        if (isOpen && openModal) {
            patchData(openModal);
        }
    }, [isOpen, openModal]);

    const [formData, setFormData] = useState<any>({
        companyName: "",
        phoneNumber: "",
        mcNumber: "",
        dotNumber: "",
        address: "",
        website: null,
        carrierSetup: null,
        loadBoard: null,
        linkedin: null,
        facebook: null,
        instagram: null,
        xcom: null,
        priority: 9999,
    });

    const [error, setError] = useState<any>({});

    const patchData = (data: any) => {
        setFormData({
            companyName: data.companyName || "",
            phoneNumber: data.phoneNumber || "",
            mcNumber: data.mcNumber || "",
            dotNumber: data.dotNumber || "",
            address: data.address || "",
            website: data.website || null,
            carrierSetup: data.carrierSetup || null,
            loadBoard: data.loadBoard || null,
            linkedin: data.linkedin || null,
            facebook: data.facebook || null,
            instagram: data.instagram || null,
            xcom: data.xcom || null,
            priority: data.priority || 9999,
        });
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormData((prev: any) => ({ ...prev, [name]: value }));
        setError((prev: any) => ({ ...prev, [name]: "" }));
    };

    const handlePhoneChange = (phoneNumber: string) => {
        setFormData((prev: any) => ({ ...prev, phoneNumber }));
        setError((prev: any) => ({
            ...prev,
            phoneNumber: phoneNumber ? "" : prev.phoneNumber,
        }));
    };

    const handleKeyDownSpace = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === " " && (e.target as HTMLInputElement).value.length === 0) {
            e.preventDefault();
        }
    };

    const resetForm = () => {
        setFormData({
            companyName: "",
            phoneNumber: "",
            mcNumber: "",
            dotNumber: "",
            address: "",
            website: null,
            carrierSetup: null,
            loadBoard: null,
            linkedin: null,
            facebook: null,
            instagram: null,
            xcom: null,
            socialMedia: null,
            priority: 9999,
        });
        setError({});
    };

    const hideErrorCustomer = () => {
        resetForm();
    };

    const getDataALLs = () => {
        props.getDataALLs?.();
        refd.current?.getDataALLs();
    };

    useImperativeHandle(ref, () => ({
        hideErrorCustomer,
    }));

    const save = async () => {
        let isValid = true;
        const newError: { [key: string]: string } = {};
        const regexNumbers = /^[0-9]*$/;

        const trimmed = {
            ...formData,
            companyName: formData.companyName.trim(),
            mcNumber: formData.mcNumber.trim(),
            dotNumber: formData.dotNumber.trim(),
            address: formData.address.trim(),
        };

        if (!trimmed.companyName) {
            newError.companyName = "Required";
            isValid = false;
        }

        if (!trimmed.phoneNumber) {
            newError.phoneNumber = "Required";
            isValid = false;
        }

        if (!trimmed.address) {
            newError.address = "Required";
            isValid = false;
        }

      

        if (!trimmed.dotNumber) {
            newError.dotNumber = "Required";
            isValid = false;
        } else if (!regexNumbers.test(trimmed.dotNumber)) {
            newError.dotNumber = "Only numbers are allowed.";
            isValid = false;
        }

        if (!trimmed.mcNumber) {
            newError.mcNumber = "Required";
            isValid = false;
        } else if (!regexNumbers.test(trimmed.mcNumber)) {
            newError.mcNumber = "Only numbers are allowed.";
            isValid = false;
        }

        setError(newError);

        if (isValid) {
            try {
                let response;

                if (openModal?._id) {
                    // Update
                    response = await putData(
                        `${ApiUrl.createBoxTruck}/${openModal._id}`,
                        trimmed);
                } else {
                    // Create
                    response = await postData(
                        ApiUrl.createBoxTruck,
                        trimmed,
                        { show, hide }
                    );
                }

                const messageServicesd = messageService();

                messageServicesd.toast(
                    "success",
                    openModal?._id
                        ? messageServicesd.message.updatedSuccess
                        : messageServicesd.message.addedSuccess
                );

                closeModal();
                resetForm();
                getDataALLs();

                if (response?.error?.message) {
                    showAPiError_mesage(response.error.message);
                }
            } catch (err: any) {
                if (err?.response?.data?.message) {
                    showAPiError_mesage(err.response.data.message);
                }
            }
        }
    };

    const inputClass =
        "w-full p-2 text-md border border-gray-300 rounded-md outline-[1px] transition-all duration-500 hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]";

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            contentLabel="Add Box Truck Modal"
            ariaHideApp={false}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            overlayClassName="fixed inset-0 bg-black bg-opacity-50"
        >
            <div className="bg-white !w-[30rem] rounded-lg max-w-2xl shadow-xl">
                {/* Header */}
                <div className="flex justify-between items-center p-4 border-b">
                    <h2 className="text-xl font-semibold">
                        {openModal?._id ? "Edit Box Truck" : "Add Box Truck"}
                    </h2>
                    <button
                        type="button"
                        className="text-gray-500 hover:text-gray-700"
                        onClick={() => {
                            resetForm();
                            closeModal();
                        }}
                        aria-label="Close"
                    >
                        <img src={pluseicon} alt="Close" />
                    </button>
                </div>

                <div className="space-y-2 p-4">
                    {/* Company Name */}
                    <div>
                        <input
                            type="text"
                            placeholder="Company Name"
                            className={inputClass}
                            value={formData.companyName}
                            name="companyName"
                            onChange={handleChange}
                            onKeyDown={handleKeyDownSpace}
                        />
                        {error.companyName && (
                            <div className="text-red-500 text-sm">{error.companyName}</div>
                        )}
                    </div>

                    {/* Phone Number */}
                    <div>
                        <PhoneInput
                            inputClass="w-full p-2 text-md focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)] border border-red-300 rounded-md bg-white outline-[1px] transition-all duration-500"
                            containerClass="w-full p-1 text-md border border-gray-300 rounded-md bg-white outline-[1px] transition-all duration-500 hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                            country={"us"}
                            value={formData.phoneNumber}
                            onChange={handlePhoneChange}
                            disableDropdown
                            countryCodeEditable={true}
                        />
                        {error.phoneNumber && (
                            <div className="text-red-500 text-sm">{error.phoneNumber}</div>
                        )}
                    </div>

                    {/* Priority */}
                    <div className="mt-5">
                        <select
                            className={inputClass}
                            name="priority"
                            value={formData.priority}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (!isEmptyString(value)) {
                                    setFormData((prev: any) => ({
                                        ...prev,
                                        priority: Number(value),
                                    }));
                                }
                            }}
                        >
                            <option value={9999} disabled>
                                Select Priority
                            </option>
                            {Array.from({ length: 50 }, (_, index) => index + 1).map(
                                (num) => (
                                    <option
                                        disabled={props?.selectedPriorities?.includes(num)}
                                        key={num}
                                        value={num}
                                    >
                                        {num}
                                    </option>
                                )
                            )}
                        </select>
                    </div>
                    <div className="flex gap-2">
                        {/* MC Number */}
                        <div className="flex-1">
                            <input
                                type="text"
                                placeholder="MC Number"
                                className={inputClass}
                                value={formData.mcNumber}
                                name="mcNumber"
                                onChange={handleChange}
                            />
                            {error.mcNumber && (
                                <div className="text-red-500 text-sm">{error.mcNumber}</div>
                            )}
                        </div>

                        {/* DOT Number */}
                        <div className="flex-1">
                            <input
                                type="text"
                                placeholder="DOT Number"
                                className={inputClass}
                                value={formData.dotNumber}
                                name="dotNumber"
                                onChange={handleChange}
                            />
                            {error.dotNumber && (
                                <div className="text-red-500 text-sm">{error.dotNumber}</div>
                            )}
                        </div>
                    </div>
                   

                    {/* Website */}
                    <div>
                        <input
                            type="text"
                            placeholder="Website"
                            className={inputClass}
                            value={formData.website || ""}
                            name="website"
                            onChange={handleChange}
                        />
                    </div>

                    {/* Carrier Setup */}
                    <div>
                        <input
                            type="text"
                            placeholder="Carrier Setup"
                            className={inputClass}
                            value={formData.carrierSetup || ""}
                            name="carrierSetup"
                            onChange={handleChange}
                        />
                    </div>

                    {/* Load Board */}
                    <div>
                        <input
                            type="text"
                            placeholder="Load Board"
                            className={inputClass}
                            value={formData.loadBoard || ""}
                            name="loadBoard"
                            onChange={handleChange}
                        />
                    </div>

                    {/* LinkedIn */}
                    <div>
                        <input
                            type="text"
                            placeholder="LinkedIn"
                            className={inputClass}
                            value={formData.linkedin || ""}
                            name="linkedin"
                            onChange={handleChange}
                        />
                    </div>

                    {/* Facebook */}
                    <div>
                        <input
                            type="text"
                            placeholder="Facebook"
                            className={inputClass}
                            value={formData.facebook || ""}
                            name="facebook"
                            onChange={handleChange}
                        />
                    </div>

                    {/* X.com */}
                    <div>
                        <input
                            type="text"
                            placeholder="X.com"
                            className={inputClass}
                            value={formData.xcom || ""}
                            name="xcom"
                            onChange={handleChange}
                        />
                    </div>

                    {/* Instagram */}
                    <div>
                        <input
                            type="text"
                            placeholder="Instagram"
                            className={inputClass}
                            value={formData.instagram || ""}
                            name="instagram"
                            onChange={handleChange}
                        />
                    </div>

                    <div >
                            <input
                                type="text"
                                placeholder="Address"
                                className={inputClass}
                                value={formData.address}
                                name="address"
                                onChange={handleChange}
                                onKeyDown={handleKeyDownSpace}
                            />
                            {error.address && (
                                <div className="text-red-500 text-sm">{error.address}</div>
                            )}
                        </div>

                    {/* Save Button */}
                    <div className="flex justify-end items-center pt-4 border-t">
                        <button
                            type="button"
                            className="px-6 py-2 bg-customOrange text-white rounded-md hover:bg-greenBg text-sm font-semibold flex items-center justify-center ease-in-out duration-500 shadow-[1px_2px_2px_rgba(0,0,0,0.3)]"
                            onClick={save}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
});

export default AddBoxTruck;